// extracted by mini-css-extract-plugin
export default {"flex":"RecomposeLotDate_flex__Mfp1+","title":"RecomposeLotDate_title__qOK+B","input_text":"RecomposeLotDate_input_text__M0JV8"};